import { createFileRoute } from '@tanstack/react-router'
import { ResumeExtractionPlayground } from '@/features/admin/resume-extraction-playground'

export const Route = createFileRoute('/_authenticated/admin/resume-extraction-playground/')({
  component: ResumeExtractionPlayground,
})
